export enum FlexBoxWrap {
  /**
   * All will stay on one line. <br />
   * <b>Note:</b> Corresponds to `nowrap`.
   */
  NoWrap = 'NoWrap',
  /**
   * Items will wrap onto multiple lines. (top to bottom)<br />
   * <b>Note:</b> Corresponds to `wrap`.
   */
  Wrap = 'Wrap',
  /**
   * Items will wrap onto multiple lines. (bottom to top)<br />
   * <b>Note:</b> Corresponds to `wrap-reverse`.
   */
  WrapReverse = 'WrapReverse'
}
